import { initializeApp, getApps } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  setPersistence, 
  browserLocalPersistence,
  connectAuthEmulator
} from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

//console.log('Firebase-Config wird geladen');
//console.log('API KEY', process.env.REACT_APP_FIREBASE_API_KEY);

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

console.log(process.env.REACT_APP_FIREBASE_API_KEY);

// Firebase initialisieren
let app;
try {
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
  //console.log('Firebase App initialisiert:', app.name);
} catch (error) {
  console.error('Fehler bei Firebase-Initialisierung:', error);
}

// Auth und Firestore initialisieren
const auth = getAuth(app);
//console.log('Firebase Auth initialisiert');

const db = getFirestore(app);
//console.log('Firestore initialisiert');

// Storage initialisieren
const storage = getStorage(app);

// Emulatoren im Entwicklungsmodus
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);
}

// Auth-Persistenz konfigurieren
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Fehler beim Setzen der Auth-Persistenz:", error);
  });

// Debug-Logging
if (process.env.REACT_APP_DEBUG === 'true') {
  auth.onAuthStateChanged((user) => {
    console.log("Auth State Changed:", {
      isSignedIn: !!user,
      uid: user ? user.uid : null,
      email: user ? user.email : null, 
      displayName: user ? user.displayName : null,
      isAnonymous: user ? user.isAnonymous : null,
      providerId: user ? user.providerId : null
    });
  });
}

// Google Auth Provider konfigurieren
const provider = new GoogleAuthProvider();
provider.addScope('profile');
provider.addScope('email');
provider.setCustomParameters({
  prompt: 'select_account'
});

export { auth, storage, db, provider };
export default app;
